<div class="chat-conv" [class.chat-conv--compact]="compact">
  <!-- No chat API answering. Outranks every other state here, including an open thread: whatever is
       on screen came from a session that can no longer be refreshed. -->
  <div class="chat-conv__placeholder" *ngIf="store.chatUnavailable()">
    <i class="pi pi-exclamation-triangle chat-conv__placeholder-warn"></i>
    <p>Please refresh your browser</p>
    <span>Chat could not reach the server.</span>
  </div>

  <!-- Empty state: nothing selected yet -->
  <div class="chat-conv__placeholder" *ngIf="!store.chatUnavailable() && !store.activeId()">
    <i class="pi pi-comments"></i>
    <p>Select a conversation</p>
    <span>Pick someone from your office or open a group to start chatting.</span>
  </div>

  <ng-container *ngIf="!store.chatUnavailable() && store.activeId()">
    <header class="chat-conv__header">
      <button type="button" class="chat-conv__back" *ngIf="compact" (click)="back.emit()" aria-label="Back to conversations">
        <i class="pi pi-arrow-left"></i>
      </button>

      <span class="chat-conv__icon" *ngIf="isGroup">
        <i class="pi pi-users"></i>
      </span>
      <!-- `[avatar]` matters as much as the name here: without it the header could only ever draw
           initials, next to a sidebar row that was showing the person's photo. -->
      <app-chat-avatar
        *ngIf="!isGroup"
        [name]="store.activeTitle()"
        [avatar]="store.activeAvatar()"
        [status]="store.activePresence()"
        [size]="compact ? 30 : 36"></app-chat-avatar>

      <div class="chat-conv__identity">
        <span class="chat-conv__title">{{ store.activeTitle() }}</span>
        <span class="chat-conv__subtitle">{{ store.activeTypingLabel() || store.activeSubtitle() }}</span>
      </div>

      <div class="chat-conv__tools">
        <!--
          Starts a Meet and posts the link to the thread, so it reaches everyone, not just this tab.

          Stays enabled without a Google connection rather than going grey: a disabled button with
          a tooltip nobody hovers is a dead end, whereas pressing this one opens the connect flow
          and then starts the call by itself. The dot is what says it will ask for something first.
        -->
        <button
          type="button"
          class="chat-conv__tool chat-conv__tool--call"
          [class.is-disconnected]="store.googleConnected() === false"
          [disabled]="store.startingCall() || store.composerDisabled()"
          (click)="startCall()"
          [title]="store.googleConnected() === false ? 'Connect Google Calendar to start video calls' : 'Start a Google Meet video call'"
          [attr.aria-label]="store.googleConnected() === false ? 'Connect Google Calendar to start video calls' : 'Start a Google Meet video call'">
          <i class="pi" [ngClass]="store.startingCall() ? 'pi-spin pi-spinner' : 'pi-video'"></i>
        </button>

        <!-- Shown in the widget too: it is the only route to the member list on a narrow screen,
             and unlike "Manage group" it is not owner-only. -->
        <button
          type="button"
          class="chat-conv__tool"
          *ngIf="isGroup"
          (click)="toggleInfo.emit()"
          [class.is-active]="infoOpen"
          title="Group info"
          aria-label="Group info">
          <i class="pi pi-info-circle"></i>
        </button>

        <button type="button" class="chat-conv__tool" *ngIf="isGroup" (click)="toggleMenu()" title="More" aria-label="More actions">
          <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="chat-conv__menu" *ngIf="menuOpen">
          <!-- Owner-only actions are hidden rather than disabled: a member never sees a control they can't use -->
          <button type="button" *ngIf="store.isActiveGroupOwner()" (click)="openManage()"><i class="pi pi-pencil"></i> Manage group</button>
          <button type="button" (click)="copyGroup()"><i class="pi pi-copy"></i> Copy group</button>
          <button type="button" (click)="leaveGroup()"><i class="pi pi-sign-out"></i> Leave group</button>
          <button type="button" class="is-danger" *ngIf="store.isActiveGroupOwner()" (click)="deleteGroup()">
            <i class="pi pi-trash"></i> Delete group
          </button>
        </div>
      </div>
    </header>

    <app-chat-message-list></app-chat-message-list>

    <app-chat-composer
      [disabled]="!store.activeId() || store.composerDisabled()"
      [notice]="store.composerNotice()"
      [compact]="compact"
      [placeholder]="'Message ' + store.activeTitle()"
      (submitted)="send($event)"
      (typing)="onTyping()"></app-chat-composer>
  </ng-container>
</div>
